import React from 'react';
import PropTypes from 'prop-types';
import { Card, Tooltip } from 'antd';
import { Link } from 'react-router-dom';
import { translate } from 'react-i18next';
import i18next from 'i18next';
import { get } from 'lodash';

import PaginationTop from 'Parts/search/PaginationTop';
import ResultThumbnailList from 'Parts/search/ResultThumbnailList';
import {
  DEFAULT_COMPACT_PAGER_NO_ADD_SEARCH_PAGE,
  SEARCHPAGESIZE_OPTIONS
} from 'Parts/search/searchUtils';
import AvatarThumbnail from '../../common/AvatarThumbnail';

import SearchParticipantPanel_en from './locales/SearchParticipantPanel_en.json';
import SearchParticipantPanel_fr from './locales/SearchParticipantPanel_fr.json';

class SearchParticipantPanel extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      pager: {
        ...DEFAULT_COMPACT_PAGER_NO_ADD_SEARCH_PAGE,
        total: props.pagination.totalResults || 0,
        current: props.pagination.pageNumber || 1,
        pageSize: props.pagination.pageResults || 12
      }
    };

    i18next.addResourceBundle('en', 'SearchParticipantPanel', SearchParticipantPanel_en);
    i18next.addResourceBundle('fr', 'SearchParticipantPanel', SearchParticipantPanel_fr);
  }

  componentDidUpdate(prevProps) {
    // Update the pager with the new total
    let pager;

    if (prevProps.pagination.pageNumber !== this.props.pagination.pageNumber) {
      pager = {
        ...this.state.pager,
        total: this.props.pagination.totalResults || 0,
        current: this.props.pagination.pageNumber || 1,
        pageSize: this.props.pagination.pageResults || 12
      };

      this.setState({ pager });
    }
  }

  handlePaginationChange = pager => {
    this.setState({ pager });
    const pagination = {
      pageNumber: pager.current,
      pageResults: pager.pageSize
    };
    this.props.searchParticipants(
      this.props.platformId,
      this.props.participants.search,
      this.props.participants.filters,
      pagination,
      { orderBy: 'addedOn[desc]' },
      false,
      false,
      this.props.from === 'donation'
    );
  };

  handleThumbnailClick = campaign => {
    //return this.props.selectCampaign(campaign);
  };

  getLinkTo = participant => {
    const { t, locale } = this.props;
    const { campaignAlias, teamAlias, member } = participant;

    if (this.props.from === 'donation') {
      if (teamAlias) {
        return {
          pathname: `/${locale}/${campaignAlias}/${teamAlias}/${participant.id}/${t('URL:give')}`
        };
      } else {
        return {
          pathname: `/${locale}/${campaignAlias}/${t('URL:individual-participant')}/${
            participant.id
          }/${t('URL:give')}`
        };
      }
    } else {
      return `/${locale}/${campaignAlias}/${teamAlias || t('URL:individual-participant')}/${
        participant.id
      }`;
    }
  };

  handleOnChangePaginationBottom = (page, pageSize) => {
    this.setState({
      pager: {
        ...this.state.pager,
        current: page,
        pageSize: pageSize
      }
    });
    const pagination = {
      pageNumber: page,
      pageResults: pageSize
    };
    this.props.searchParticipants(
      this.props.platformId,
      this.props.participants.search,
      this.props.participants.filters,
      pagination,
      { orderBy: 'addedOn[desc]' },
      false,
      false,
      this.props.from === 'donation'
    );
  };

  render() {
    const { t, from } = this.props;

    return (
      <div className="SearchTeamPanel">
        <PaginationTop
          totalLabel={total => t('participants', { count: total })}
          pager={this.state.pager}
          onChange={this.handlePaginationChange}
          pageSizeOptions={SEARCHPAGESIZE_OPTIONS}
        />
        <ResultThumbnailList
          rowKey="id"
          dataSource={this.props.participants}
          onThumbnailClick={this.handleThumbnailClick}
          renderRecord={participant =>
            from !== 'donation' ||
            (from === 'donation' && get(participant, 'actions.canReceiveDonations', false)) ? (
              <Link to={this.getLinkTo(participant)}>
                <Card bordered={false}>
                  <AvatarThumbnail
                    entity={participant}
                    primaryContent={participant.member.name}
                    secondaryContent={participant.campaignName}
                    avatarSize={58}
                  />
                </Card>
              </Link>
            ) : (
              <Tooltip placement="bottom" title={t('SearchPage:donation-disabled')}>
                <Card bordered={false} className="card-disabled">
                  <AvatarThumbnail
                    entity={participant}
                    primaryContent={participant.member.name}
                    secondaryContent={participant.campaignName}
                    avatarSize={58}
                  />
                </Card>
              </Tooltip>
            )
          }
          pagination={this.state.pager}
          onChange={this.handleOnChangePaginationBottom}
        />
      </div>
    );
  }
}

SearchParticipantPanel.defaultProps = {
  participants: [],
  pagination: {
    totalResults: 0
  },
  from: null
};

SearchParticipantPanel.propTypes = {
  participants: PropTypes.array,
  pagination: PropTypes.object,
  from: PropTypes.string
};

export default translate('SearchParticipantPanel')(SearchParticipantPanel);
